export class ApiRoutes {
    static LOGIN = "/auth/token";
    static LOGOUT = "/auth/logout";
    static REFRESH_TOKEN = "/auth/token/refresh";
    static REGISTER_ADMIN = "/auth/register/admin";
    static REGISTER_TEACHER = "/auth/register/teacher";
    static REGISTER_HOMESCHOOL = "/auth/register/homeschool";
    static AUTH_USER = "/auth/me";
    static AUTH_SIGNUP_INTENT = "/auth/me/signup-intent";
    static FORGOT_PASSWORD = "/auth/forgot-password";
    static RESET_PASSWORD = "/auth/reset-password";
    static VERIFY_EMAIL = "/auth/verify-email";
    static RESEND_VERIFICATION = "/auth/resend-verification";

    static SCHOOL_USER = "/users";
    static SCHOOL_USERS = "/users";
    static SCHOOLS = "/schools";

    static INVITE_TOKEN_USER = "/user/token";
    static INVITE_PREVIEW = "/auth/invite/preview";
    static INVITE_ACCEPT = "/auth/invite/accept";
    static INVITE_SCHOOL_USER = "/users/invite";
    static SEND_INVITE = "/users/invite";
    static IMPORT_USERS_BULK = "/users/import-bulk";

    static GRADING_SYSTEM = "/grade-schemes";
    static GRADING_SYSTEMS = "/grade-schemes";

    // New backend endpoints
    static RUBRICS = "/rubrics";
    static RUBRIC_TEMPLATES = "/rubrics/templates";
    static GRADE_SCHEMES = "/grade-schemes";
    static GRADE_SCHEME_TEMPLATES = "/grade-schemes/templates";

    static CLASSROOMS = "/classrooms";
    static DEMO_CLASSROOM = "/demo-classroom";

    static SUBJECTS = "/subjects";
    static SUBJECT_SUGGESTIONS = "/subjects/suggestions";
    static SUBJECT_TAGS = "/subjects/tags";

    static ASSESSMENTS = "/assessments";

    static REPORT_TEMPLATES = "/report-templates";
    static REPORT_TEMPLATE_PREVIEW = "/report-templates/preview";
    static REPORTS_PREVIEW = "/reports/preview";

    static PREVIEW_RESULT = "/result/preview";
    static PRINT_RESULT = "/result/print";
    static SHARE_RESULT = "/result/share";

    static PLANS = "/plans";
    static SUBSCRIBE_TO_PLAN = "/subscribe";
    static BILLS = "/bills";
    static PAY_BILL = "/pay/bill";
    static BILLING_PLANS = "/billing/plans";
    static BILLING_BASE = "/billing";

    static DASHBOARD_SCHOOL = "/dashboard/school";
    static DASHBOARD_TEACHER_ANALYTICS = "/dashboard/teacher";
}
